<template>
  <div class="login_container">
    <div class="login_box">
      <!-- 头像区 -->
      <div class="avatar_box" v-loading="fullscreenLoading">
        <img :src="formSite.imageUrl" />
        <h3>{{ formSite.SystemName }}</h3>
      </div>
      <!-- 登录表单 -->
      <el-form
        ref="loginFormRef"
        :model="loginForm"
        :rules="loginFormRules"
        label-width="0"
        class="login_form"
      >
        <!-- 用户名 -->
        <el-form-item prop="LoginID">
          <el-input
            v-model="loginForm.LoginID"
            prefix-icon="el-icon-user"
            placeholder="管理员/评审"
          ></el-input>
        </el-form-item>
        <!-- 密码 -->
        <el-form-item prop="JudgesPwd">
          <el-input
            v-model="loginForm.JudgesPwd"
            prefix-icon="el-icon-lock"
            type="password"
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <!-- 按钮 -->
        <el-form-item class="btns">
          <el-button type="primary" @click="login" @keydown="keydownLogin"
            >登录</el-button
          >
          <el-button type="info" @click="resetLoginForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <canvas id="login-canvas"></canvas>
  </div>
</template>

<script>
import bus from '../bus'
export default {
  data() {
    return {
      loginForm: {
        LoginID: '',
        JudgesPwd: ''
      },
      //   表单验证规则
      loginFormRules: {
        LoginID: [
          { required: true, message: '请输入登录名称', trigger: 'blur' },
          { min: 4, max: 30, message: '长度在 4 到30 个字符', trigger: 'blur' }
        ],
        JudgesPwd: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 4, max: 30, message: '长度在 4 到30 个字符', trigger: 'blur' }
        ]
      },
      // logo信息
      formSite: {
        imageUrl: '',
        SystemName: ''
      },
      // 加载中
      fullscreenLoading: true
    }
  },
  created() {
    this.getLogoInfo()
    // 监听键盘事件
    window.addEventListener('keydown', this.keydownLogin)
  },
  destroyed() {
    // 销毁键盘事件
    window.removeEventListener('keydown', this.keydownLogin)
  },
  mounted() {
    // 接收WebSite.vue页面发送的数据
    bus.$on('uplogosrc', (data) => {
      this.formSite = data
    })
    // 初始加载canvas
    this.getCanvas()
    // 页面变化重新加载canvas
    window.onresize = () => {
      this.getCanvas()
    }
  },
  methods: {
    resetLoginForm() {
      // 点重置，重置登录表单
      this.$refs.loginFormRef.resetFields()
    },
    keydownLogin(e) {
      if (e.keyCode === 13) {
        this.login()
      }
    },
    // 回填logo和系统名称
    async getLogoInfo() {
      const { data: res } = await this.$http.get(
        '/api/SiteSettings/GetSiteSettings'
      )
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.formSite = {
        imageUrl: process.env.VUE_APP_BASE_URL + res.Data.FileName,
        SystemName: res.Data.SystemName
      }
      this.fullscreenLoading = false
    },
    // 表单预验证，验证失败返回false,验证成功返回true
    login() {
      this.$refs.loginFormRef.validate(async (valid) => {
        if (!valid) return
        const { data: res } = await this.$http.post(
          '/api/Login/LoginIn',
          this.loginForm
        )
        if (res.StatusCode !== 1) return this.$message.error(res.Msg)
        this.$message.success(res.Msg)
        console.log(res)
        window.localStorage.setItem('token', res.Data.token)
        window.localStorage.setItem('LoginID', res.Data.LoginID)
        window.localStorage.setItem('LoginType', res.Data.LoginType)
        window.localStorage.setItem('JudgesName', res.Data.JudgesName)
        if (res.Data.LoginType === 1) {
          this.$router.push({ path: '/system' }).catch((err) => {
            console.log(err)
          })
        } else if (res.Data.LoginType === 2) {
          this.$router.push({ path: '/reviewwelcome' }).catch((err) => {
            console.log(err)
          })
        }
      })
    },
    getCanvas() {
      const canvas = document.querySelector('#login-canvas')
      if (canvas) {
        const ctx = canvas.getContext('2d')
        canvas.width =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth
        canvas.height =
          window.innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight
        const MAX_STARS = 250
        const STAR_COLORS = ['#444', '#888', '#FFF']

        class Stars {
          constructor() {
            this.stars = []
            for (let i = 0; i < MAX_STARS; i++) {
              const x = ~~(Math.random() * canvas.width)
              const y = ~~(Math.random() * canvas.height)
              const speed = ~~(1 + Math.random() * 5)
              const color = ~~(Math.random() * 3)
              this.stars.push({ x, y, speed, color })
            }
          }

          draw() {
            for (let i = 0; i < MAX_STARS; i++) {
              const star = this.stars[i]
              ctx.lineWidth = 1
              ctx.strokeStyle = STAR_COLORS[this.stars[i].color]
              ctx.strokeRect(star.x, star.y, 1, 1)
            }
          }

          update() {
            for (let i = 0; i < MAX_STARS; i++) {
              this.stars[i].y += this.stars[i].speed
              const isOutScreen = this.stars[i].y > canvas.height
              isOutScreen && (this.stars[i].y = 0)
            }
          }
        }

        const stars = new Stars()

        const clearScreen = () =>
          ctx.clearRect(0, 0, canvas.width, canvas.height)

        const loop = () => {
          clearScreen()
          requestAnimationFrame(loop)
          stars.update()
          stars.draw()
        }

        loop()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.login_container {
  background: linear-gradient(rgb(7, 172, 184), rgb(8, 121, 173));
  height: 100%;
  overflow: hidden;
}
.login_box {
  width: 450px;
  height: 360px;
  background-color: #fff;
  border-radius: 3px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.avatar_box {
  position: absolute;
  left: 50%;
  top: 86px;
  color: #666;
  transform: translate(-50%, -50%);
  text-align: center;
  img {
    height: 60px;
  }
}
.btns {
  display: flex;
  justify-content: flex-end;
}
.login_form {
  position: absolute;
  bottom: 0;
  padding: 0 10px;
  width: 100%;
  box-sizing: border-box;
}
</style>
